import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { useLocation } from "react-router-dom";
import useApi from "../hooks/useApi";
import apiClient from "../api/apiClient";

const WaitingPage = () => {
  const { state: email } = useLocation();
  const [timer, setTimer] = useState(60);
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      } else {
        setIsResendButtonDisabled(false);
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const { request, loading, error } = useApi((email) =>
    apiClient.post("/authentication/resend-verification-email/", {
      email: email,
    })
  );
  const handleResendEmail = async () => {
    const res = await request(email);
    if (res.ok) {
      setTimer(120);
      setIsResendButtonDisabled(true);
    }
  };

  return (
    <div className="container p-4">
      <h2>Waiting for Email Verification</h2>
      <div>
        Please check your email for a verification link. If you haven't received
        an email, you can resend it in:
      </div>
      <h6>
        {`${Math.floor(timer / 60)}:${(timer % 60)
          .toString()
          .padStart(2, "0")}`}
      </h6>
      <Button
        variant="primary"
        onClick={handleResendEmail}
        disabled={isResendButtonDisabled}
      >
        Resend Email
      </Button>
    </div>
  );
};

export default WaitingPage;
